import { render, staticRenderFns } from "./weighing_record.vue?vue&type=template&id=8ec3a462&scoped=true&"
import script from "./weighing_record.vue?vue&type=script&lang=js&"
export * from "./weighing_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ec3a462",
  null
  
)

export default component.exports